import Button from '@material-ui/core/Button'
import { Auth } from 'aws-amplify'
import React, { useState } from 'react'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import WebFooter from '../../source/WebScreen/WebFooter'
import '../authentication/Login.css'
import styles from './LoginForm.module.css'
import { getQueryParams } from '../authentication/utils'
import InputPassword from './InputPasswordBox'
import PasswordValidations from './PwdValidations'
function ResetPasswordForm(props) {
  const [verificationCode, setVerification] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [disableSendBtn, setDisableSendBtn] = useState(true)

  const handleConfirmVerification = e => {
    e.preventDefault()
    console.log('calling reset')
    console.log(props.email)
    console.log(verificationCode)
    console.log(password)
    if (password == confirmPassword) {
      props.toggleLoader(true)
      Auth.completeNewPassword(props.user, password)
        .then(user => {
          console.log(user)
          props.toggleLoader(false)
          let queryParams = getQueryParams()
          console.log(queryParams)
          if (queryParams.u) {
            let userName = decodeURI(queryParams.u)
            let url = window.location.href.split('?')[0] + '?u=' + userName + '&p=' + password
            window.location.replace(url)
          } else {
            window.location.reload()
          }
        })
        .catch(err => {
          props.toggleLoader(false)
          console.log(err.message)
          setErrorMessage(err.message)
        })
    } else {
      setErrorMessage('Please enter same password')
    }
  }

  const handleChange = e => {
    if (e.target.name == 'password') {
      setPassword(e.target.value)
    } else if (e.target.name == 'confirmPassword') {
      setConfirmPassword(e.target.value)
    }
  }
  const toggleResetBtn = allPassed => {
    setDisableSendBtn(!allPassed)
  }

  return (
    <div>
      {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') ? (
        <div className="loginformnew">
          <div className={styles.loginform_flex_container}>
            {/* Left Panel: Image and Footer */}
            <div className={styles.loginform_left_panel}>
              <div className={styles.loginform_image_wrapper}>
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} className={styles.loginform_main_image} alt="welcome" />
              </div>
              <div className={styles.loginform_footer}>
                Copyright © 2019-2026 Universal Health Fellowship. All rights reserved. | Powered by CarynHealth<br />
                Version 6.1.0
              </div>
            </div>
            {/* Right Panel: Form */}
            <div className={styles.loginform_right_panel}>
              <form onSubmit={handleConfirmVerification} className={styles.loginform_form_wrapper}>
                <img src={require('../../source/Images/Banner/logo.png')} className={styles.login_uhs_logo} alt="logo" />
                <div className={styles.login_input_container}>
                  <div className={styles.password_change_header}>
                    <div className={styles.password_change_title}>Change Password</div>
                    <div className={styles.password_change_subtitle}>Please enter your new password below.</div>
                  </div>

                  {errorMessage.length > 0 && (
                    <div className={styles.login_error_message}>{errorMessage}</div>
                  )}

                  <div className={styles.password_input_wrapper}>
                    <label className={styles.password_label}>New Password</label>
                    <InputPassword handleChange={handleChange} name={'password'} placeholder="Enter new password" />
                  </div>

                  <div className={styles.password_input_wrapper}>
                    <label className={styles.password_label}>Enter New Password Again</label>
                    <InputPassword handleChange={handleChange} name={'confirmPassword'} placeholder="Enter new password" />
                  </div>

                  <Button type="submit" className={["login_button", styles.loginform_button].join(' ')} onClick={handleConfirmVerification}>
                    SEND
                  </Button>

                  <div className={styles.password_validations_wrapper}>
                    <PasswordValidations password={password} allPassed={toggleResetBtn} />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div class="loginmobile">
          <div class="loginmobile_header">
            <div class="loginmobile_header_text">Member Portal</div>
          </div>

          <div class="loginmobile_container">
            <form>
              <div class="loginmobile_image_container">
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} class="loginmobile_banner" />
                <img src={require('../../source/Images/Banner/logo.png')} class="loginmobile_logo" />
              </div>

              <div class="firsttimemobile_bottom_text">
                <div class="firsttimemobile_bottom_subtext">Change Password</div>
                <div class="firsttimemobile_bottom_subtext2">
                  <div>Please enter your new passsword below.</div>
                </div>
              </div>

              <div class="loginmobile_input_container">
                <p className="a-errorMessage" hidden={errorMessage.length <= 0} style={{ marginTop: '10px' }}>
                  {errorMessage}
                </p>

                <div class="mobile-linput"></div>
                <div style={{ position: 'relative', marginBottom: '40px' }}>
                  <InputPassword handleChange={handleChange} name={'password'} placeholder="New password" />
                </div>

                <div style={{ position: 'relative', marginBottom: '30px' }}>
                  <InputPassword handleChange={handleChange} name={'confirmPassword'} placeholder="New password again" />
                </div>

                <Button type="submit" variant="contained" color="" class="loginmobile_button" onClick={handleConfirmVerification}>
                  Send
                </Button>
              </div>

              <div className="mt-3 passowrd_validation_center">
                <PasswordValidations password={password} allPassed={toggleResetBtn} />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default ResetPasswordForm
